import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { formattedTs } from '../utils';

export const Image = ({ showBotAvatar, imageUrl, ts }) => {
  const appContext = useContext(AppContext);
  const { botAvatar } = appContext;
  return (
    <div className="flex space-x-1">
      <div className={`flex w-6 items-end`}>
        <img
          className={`rounded-full ${showBotAvatar ? '' : 'hidden'}`}
          src={botAvatar}
          alt="BotAvatar"
        />
      </div>
      <div className="flex  flex-col space-y-1">
        <div
          className={`ml-4 w-fit min-w-[10%] max-w-[75%] self-start whitespace-pre-line  break-words text-white`}
        >
          <img className="rounded-xl shadow-sm" src={imageUrl} alt="imgAlt" />
        </div>
        {showBotAvatar && (
          <div className="text-[10px] italic  text-gray-500">
            {formattedTs(ts)}
          </div>
        )}
      </div>
    </div>
  );
};
